import api from '@/api/api'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async getServiciosTipo({ dispatch }) {
      return new Promise((resolve, reject) => {
        api
          .get('/cms/services/get_list_services')
          .then(response => {
            if (response.data.ok) {
              resolve(response.data.data)
            } else {
              dispatch('alerts/add', { text: response.data.message, color: 'error' }, { root: true })
              reject(response.data)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    async getServiciosRating({ dispatch }) {
      return new Promise((resolve, reject) => {
        api
          .get('/cms/services/get_list_services_ratings')
          .then(response => {
            if (response.data.ok) {
              resolve(response.data.data)
            } else {
              dispatch('alerts/add', { text: response.data.message, color: 'error' }, { root: true })
              reject(response.data)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    async getServicios({ dispatch }, obj) {
      return new Promise((resolve, reject) => {
        api
          .get('/cms/services/get_reservation_services', {
            params: obj
          })
          .then(response => {
            if (response.data.ok) {
              resolve(response.data.data)
            } else {
              dispatch('alerts/add', { text: response.data.message, color: 'error' }, { root: true })
              reject(response.data)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    async validarServicio({ dispatch }, obj) {
      return new Promise((resolve, reject) => {
        api
          .post('/cms/services/validate_service', obj)
          .then(response => {
            if (response.data.ok) {
              resolve(response.data.data)
            } else {
              dispatch('alerts/add', { text: response.data.message, color: 'error' }, { root: true })
              reject(response.data)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    async rechazarServicio({ dispatch }, obj) {
      return new Promise((resolve, reject) => {
        api
          .post('/cms/services/cancel_service', obj)
          .then(response => {
            if (response.data.ok) {
              resolve(response.data.data)
            } else {
              dispatch('alerts/add', { text: response.data.message, color: 'error' }, { root: true })
              reject(response.data)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    }
  },
  getters: {}
}
